import { useEffect } from "react";
import { useAuth } from "@/context/auth";
import { useTranslation } from "@/context/TranslationContext";

const PreferredLanguageSync = () => {
  const { user } = useAuth();
  const { currentLanguage, setLanguage, staticOnlyMode } = useTranslation();

  useEffect(() => {
    if (user?.preferred_language && user.preferred_language !== currentLanguage) {
      setLanguage(user.preferred_language);
      if (!staticOnlyMode) {
        setTimeout(() => {
          const event = new CustomEvent('force-translate');
          window.dispatchEvent(event);
        }, 50);
      }
    }
  }, [user?.preferred_language, staticOnlyMode]);

  return null;
};

export default PreferredLanguageSync;
